import {
  // csak dashboard
  getAllStatisticDashbord,
  // csak dashboard

  /// для полтверждения нескольких выбросов
  changeStatusGroupEmission,
  deleteGroupEmission,
  /// для полтверждения нескольких выбросов

  getCart,
  getDashboardData,
  //ObjectDailyPollutionEmissions api Отправка на модерацию данных
  getObjectDailyPollutionEmissions,
  addObjectDailyPollutionEmissions,
  editObjectDailyPollutionEmissions,
  deleteObjectDailyPollutionEmissions,
  getObjectDailyPollutionEmissionsWithFilter, // Получение отчетов по фильтру
  getAllStatusesEmissions, // возвращает все выды статусов emissions
  changeEmissionStatus, // изменяет статус определенного выброса с коментом
  getCommentsDailyPollutionEmissions, // API для получения списка комментариев для определенного emission
  addCommentsDailyPollutionEmissions, // API для добавления нового комментария к определенному emission
  deleteCommentsDailyPollutionEmissions, // API для удаления комментария определенного emission
} from "../../api/emissions";

export default {


  //  CSAK staistics dashboard статистика для ТСАКа

  fetchAllStatisticDashbord({
    commit
  }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      getAllStatisticDashbord(a)
        .then(res => {
          if (!a.excel) {
            commit("SET_STATISTIC_DASHBOARD_CSAK", res.data.data);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  //!  CSAK staistics dashboard статистика для ТСАКа

  /// для полтверждения нескольких выбросов
  changeGroupModerationEmissionStatus({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      changeStatusGroupEmission(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  deleteGroupDailyPollutionEmissions({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      deleteGroupEmission(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },


  /// для полтверждения нескольких выбросов
  fetchAllStatusesEmissions({
    commit
  }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      getAllStatusesEmissions(a)
        .then(res => {
          commit("SET_EMISSIONS_STATUSES", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  changeModerationEmissionStatus({
    commit
  }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      changeEmissionStatus(a)
        /*{id (integer → emission id)(required) ,
          status_id (integer) (required) ,
          description ---> (text ) (not required)  } */
        .then(res => {
          // commit("SET_ALL_POLLUTION_SOURCE_NORMATIVE", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // ObjectDailyPollutionEmissions

  fetchDailyPollutionEmissions({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getObjectDailyPollutionEmissions(a)
        // Получение отчетов по источнику и компоненту { source_id : (int) , component_id: (int)}
        .then(res => {
          // commit("SET_ALL_POLLUTION_SOURCE_NORMATIVE", res.data.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchCart({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      getCart(a)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //получение отчетов для модерации с помощью фильтров
  fetchDailyPollutionEmissionsWithFilters(_, a) {
    const {
      object,
      ...rest
    } = a
    return new Promise((resolve, reject) => {
      getObjectDailyPollutionEmissionsWithFilter({
          objects: object || undefined,
          ...rest
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addDailyPollutionEmissions({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      addObjectDailyPollutionEmissions(a)
        .then(res => {
          // commit("ADD_POLLUTION_SOURCE_NORMATIVE", a);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  editDailyPollutionEmissions({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      editObjectDailyPollutionEmissions(a)
        .then(res => {
          // commit("EDIT_POLLUTION_SOURCE_NORMATIVE", a);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteDailyPollutionEmissions({
    commit
  }, a) {
    return new Promise((resolve, reject) => {
      deleteObjectDailyPollutionEmissions(a)
        .then(res => {
          // commit("EDIT_POLLUTION_SOURCE_NORMATIVE", a);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  //comments

  fetchDashboardData({
    commit
  }, a) {
    // запрашиваю все комментарии определенного emission
    return new Promise((resolve, reject) => {
      getDashboardData(a)
        .then(res => {
          // commit("SET_EMISSIONS_STATUSES", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchCommentsDailyPollutionEmissions({
    commit
  }, a) {
    // запрашиваю все комментарии определенного emission
    return new Promise((resolve, reject) => {
      getCommentsDailyPollutionEmissions(a)
        .then(res => {
          // commit("SET_EMISSIONS_STATUSES", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addCommentsDailyPollutionEmissions({
    commit
  }, a) {
    // запрашиваю все комментарии определенного emission
    return new Promise((resolve, reject) => {
      addCommentsDailyPollutionEmissions(a)
        .then(res => {
          // commit("SET_EMISSIONS_STATUSES", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  deleteCommentsDailyPollutionEmissions({
    commit
  }, a) {
    // запрашиваю все комментарии определенного emission
    return new Promise((resolve, reject) => {
      deleteCommentsDailyPollutionEmissions(a)
        .then(res => {
          // commit("SET_EMISSIONS_STATUSES", res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },


};
